export default "__VITE_PUBLIC_ASSET__287ab413__"